import { render, staticRenderFns } from "./Restriccion.vue?vue&type=template&id=5ac737f4&"
import script from "./Restriccion.vue?vue&type=script&lang=js&"
export * from "./Restriccion.vue?vue&type=script&lang=js&"
import style0 from "./Restriccion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports